import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreEnvironment } from '../../../Types/StoreTypes';
import { PaginationListType } from '../../../Types/PaginationParams';

const initialState: StoreEnvironment = {
    showUserStatistics: false,
    windowWidth: window.innerWidth,
    windowBreakpoint: 1280,
    demoInstance: false,
    isCtrlOrCmdPressed: false,
    currentURL: '',
    currentChatId: '',
    isDragActive: false,
    dragZoneRootProps: () => {},
    dragZoneInputProps: () => {},
    sourceContainerState: false,
    listReloadType: null as PaginationListType | null,
    chatlistClear: false,
    reloadPrompts: false,
    fileDlpModalState: {
        state: 'closed',
        files: [],
        combinedDlp: null,
        callback: null,
    },
};

const environmentSlice = createSlice({
    name: 'environment',
    initialState,
    reducers: {
        setShowUserStatistics: (state, action: PayloadAction<StoreEnvironment['showUserStatistics']>) => {
            state.showUserStatistics = action.payload;
        },
        setWindowWidth: (state, action: PayloadAction<StoreEnvironment['windowWidth']>) => {
            state.windowWidth = action.payload;
        },
        setWindowBreakpoint: (state, action: PayloadAction<StoreEnvironment['windowBreakpoint']>) => {
            state.windowBreakpoint = action.payload;
        },
        setDemoInstance: (state, action: PayloadAction<StoreEnvironment['demoInstance']>) => {
            state.demoInstance = action.payload;
        },
        setIsCtrlOrCmdPressed: (state, action: PayloadAction<StoreEnvironment['isCtrlOrCmdPressed']>) => {
            state.isCtrlOrCmdPressed = action.payload;
        },
        setCurrentLocation: (state, action: PayloadAction<StoreEnvironment['currentURL']>) => {
            state.currentURL = action.payload;
        },
        setCurrentChatId: (state, action: PayloadAction<StoreEnvironment['currentChatId']>) => {
            state.currentChatId = action.payload;
        },
        setIsDragActive: (state, action: PayloadAction<StoreEnvironment['isDragActive']>) => {
            state.isDragActive = action.payload;
        },
        setDragZoneRootProps: (state, action: PayloadAction<StoreEnvironment['dragZoneRootProps']>) => {
            state.dragZoneRootProps = action.payload;
        },
        setDragZoneInputProps: (state, action: PayloadAction<StoreEnvironment['dragZoneInputProps']>) => {
            state.dragZoneInputProps = action.payload;
        },
        setSourceContainerState: (state, action: PayloadAction<StoreEnvironment['sourceContainerState']>) => {
            state.sourceContainerState = action.payload;
        },
        setListReloadType: (state, action: PayloadAction<StoreEnvironment['listReloadType']>) => {
            state.listReloadType = action.payload;
        },
        setChatlistClear: (state, action: PayloadAction<StoreEnvironment['chatlistClear']>) => {
            state.chatlistClear = action.payload;
        },
        setReloadPrompts: (state, action: PayloadAction<StoreEnvironment['reloadPrompts']>) => {
            state.reloadPrompts = action.payload;
        },
        setFileDlpModalState: (state, action: PayloadAction<StoreEnvironment['fileDlpModalState']>) => {
            state.fileDlpModalState = action.payload;
        },
    },
});

export const {
    setShowUserStatistics,
    setWindowWidth,
    setWindowBreakpoint,
    setDemoInstance,
    setIsCtrlOrCmdPressed,
    setCurrentLocation,
    setCurrentChatId,
    setIsDragActive,
    setDragZoneRootProps,
    setDragZoneInputProps,
    setSourceContainerState,
    setListReloadType,
    setChatlistClear,
    setReloadPrompts,
    setFileDlpModalState,
} = environmentSlice.actions;

export default environmentSlice.reducer;
